import { getStore } from '../store/store';
import { teamsPolicyCheckImpl } from './isTeamsChatPolicyEnabled';

export function isTeamsChatPolicyEnabledWithDefault(defaultValue: boolean): boolean {
    const policies = getStore().policies;

    // If policies are not available or empty, return the default value
    // This can happen if the policies are not fetched yet or if there was an error fetching them
    if (!policies || Object.keys(policies).length === 0) {
        return defaultValue;
    }

    return teamsPolicyCheckImpl(policies);
}
